import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";
import { clearAuthStorage } from "../utils/storage";
import verifyBvnSlice from "./verifyBvn/verifyBvnSlice";
import verifyNinSlice from "./verifyNin/verifyNinSlice";
import signupSlice from "./signup/signupSlice";
import verifyCustomApiLookupSlice from "./verifyCustomApiLookup/verifyCustomApiLookupSlice";
import signupWithoutKycSlice from "./signupWithoutKyc/signupWithoutKycSlice";
import cableSubscriptionSlice from "./cableSubscriptions/cableSubscriptionSlice";

const persistConfig = {
  key: "root",
  version: 1,
  storage, // ✅ use correct storage for web
  blacklist: ["verifyBvnSlice"],
  whitelist: [],
};

const appReducer = combineReducers({
  // add your reducers here
  verifyBvnSlice,
  signupSlice,
  verifyNinSlice,
  signupWithoutKycSlice,
  verifyCustomApiLookupSlice,
  cableSubscriptionSlice,
});

export const rootReducer = (state, action) => {
  if (action.type === "login/logout") {
    clearAuthStorage();
    storage.removeItem("persist:root"); // ✅ clear persisted state from localStorage
    state = undefined;
  }
  return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        ignoredPaths: ["getTransactionHistorySlice.error"],
        warnAfter: 128,
      },
      immutableCheck: { warnAfter: 128 },
    }),
});

export default store;
